var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 28,
    viewBox: "0 0 60 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0362549,
    y: 0.804688,
    width: 59,
    height: 27,
    rx: 4,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0363 22.1035C27.0363 22.1035 35.9135 20.464 41.6954 18.0219C47.4531 15.7999 51.0363 13.1035 51.0363 13.1035V22.1035H27.0363Z",
    fill: "#F16822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5881 7.24121H43.5792C44.2145 7.24121 45.4792 7.56514 45.4792 8.92136C45.4792 10.279 44.1718 10.5599 44.1718 10.5599L46.0362 12.9453H44.5539L42.906 10.6687H42.7798V12.9453H41.5881V7.24121ZM42.7794 8.19221V9.85697H43.4354C43.9403 9.85697 44.2591 9.43159 44.2591 9.05974V8.98838C44.2591 8.61723 43.9403 8.19221 43.4354 8.19221H42.7794Z",
    fill: "#28283C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0679 7.24121H32.3813L34.0625 10.9779L35.6471 7.24121H36.9608L34.3925 13.0901H33.6362L31.0679 7.24121Z",
    fill: "#28283C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5168 12.9453H14.7369V7.24121H13.5168V12.9453Z",
    fill: "#28283C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03625 7.24121H10.0337C11.2328 7.24121 12.992 8.25882 12.992 10.0674V10.0883V10.1097C12.992 11.9186 11.2328 12.9355 10.0337 12.9355H8.03625V7.24121ZM9.1864 11.9864C9.1864 11.9864 11.7502 12.2561 11.7502 10.137V10.1037C11.7502 7.98421 9.1864 8.25427 9.1864 8.25427V11.9864Z",
    fill: "#28283C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7025 9.48849V10.4945H38.6275V11.9382H40.7984V12.9443H37.4156V7.24023H40.7984V8.2463H38.6275V9.48849H40.7025Z",
    fill: "#28283C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2823 10.1208C31.2823 11.754 29.8636 13.0777 28.115 13.0777C26.3655 13.0777 24.9473 11.754 24.9473 10.1208C24.9473 8.48713 26.3655 7.16309 28.115 7.16309C29.8636 7.16309 31.2823 8.48713 31.2823 10.1208Z",
    fill: "#F16822"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4773 8.55596C18.4773 8.55596 18.0753 8.12394 17.5355 8.12394C16.9968 8.12394 16.6855 8.45906 16.6855 8.70323C16.6855 8.9467 16.6754 9.08452 17.4452 9.38431C18.2158 9.68515 19.3483 9.90099 19.3483 11.1715C19.3483 12.441 18.2829 13.0853 17.325 13.0853C15.8138 13.0853 15.1343 12.0034 15.1343 12.0034L15.8947 11.2929C15.8947 11.2929 16.3769 12.0502 17.2179 12.0502C18.0585 12.0502 18.1053 11.4524 18.1053 11.2558C18.1053 10.9648 17.9244 10.6769 17.4052 10.4992C16.8859 10.3204 15.4662 10.1413 15.4662 8.86274C15.4662 7.71465 16.3851 7.14551 17.4153 7.14551C18.3361 7.14551 19.137 7.81855 19.137 7.81855L18.4773 8.55596Z",
    fill: "#28283C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.418 8.79311C24.0404 8.42861 23.5205 8.1638 22.9353 8.1638C21.7883 8.1638 20.8585 9.03274 20.8585 10.1032C20.8585 11.1746 21.7883 12.0425 22.9353 12.0425C23.5148 12.0425 24.0423 11.7805 24.4184 11.4227L24.418 12.7652C23.9737 12.9825 23.4706 13.1035 22.9353 13.1035C21.1608 13.1035 19.7223 11.7606 19.7223 10.1032C19.7223 8.44645 21.1608 7.10352 22.9353 7.10352C23.4721 7.10352 23.9734 7.2263 24.418 7.44423V8.79311Z",
    fill: "#28283C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.bd7a55b0185ea8afd20e9310d7fae37a.svg";
export { ForwardRef as ReactComponent };